module.exports = __webpack_public_path__ + "media/asset/images/Nissay/ITRI_company_resource_Nissay-e0e246f8aa4d7fc972915168b342d8ec.png";